import "../styles/EnrollModal.css";

function EnrollModal({ isOpen, onClose, courseName }) {
  if (!isOpen) return null;

  return (
    <div className="enroll-overlay">
      <div className="enroll-modal">
        <button className="close-btn" onClick={onClose}>×</button>

        <h2>Enroll Now</h2>
        <p className="course-name">{courseName}</p>

        <form className="enroll-form">
          <input type="text" placeholder="Student Name" required />
          <input type="email" placeholder="Email Address" required />
          <input type="tel" placeholder="Mobile Number" required />

          <button type="submit" className="submit-btn">
            Submit Request
          </button>
        </form>
      </div>
    </div>
  );
}

export default EnrollModal;
